import React, { useState, useEffect, useCallback, useRef } from 'react'
import { priceFormatter } from '../../../helpers/Numbers';
import CircleGraph from './CircleGraph';
import axios from 'axios'
import InfoTag from '../InfoTag';

const Cost = ({car, order}) => {

    const malusYears = 3;

    const calcRemainingMalus = function(car, malusYears) {
        if( (car.properties?.annualMalus ?? 0) === 0) {
            return false;
        }
        const now = new Date();
        const registered = new Date(car.registrationDate);
        const until = new Date( new Date(registered.getTime()).setFullYear(registered.getFullYear() + malusYears));

        return now < until ? until.toLocaleDateString('sv-SE') : false;
    }

    const [costs, setCosts] = useState({
        loan: order.monthlyCost,
        insurance: 0,
        tire: Math.round( 950/12 ),
        tax: Math.round( ( (car.properties?.annualTax ?? 0) + (car.properties?.annualMalus ?? 0) ) / 12 ),
        hasMalus: (car.properties?.annualMalus ?? 0) > 0,
        taxAfterMalus: Math.round( (car.properties?.annualTax ?? 0)  / 12 ),
        malusUntil: calcRemainingMalus(car, malusYears),
        service: 348
    })

    const [totalCost, setTotalCost] = useState(costs.loan + costs.tax)
    const [segments, setSegments] = useState([])
    const [insurance, setInsurance] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const personnummer = useRef()

    const [includedCosts, setIncludedCosts] = useState(['loan','tax', 'tire', 'service']);


    const storage = useCallback((val = false) => {

        const storageKey = 'bbInsuraceCosts'
        const store = JSON.parse(window.localStorage.getItem(storageKey) || '{}')
        const prefix = 'carId_' + car._id

        if(val) {
            store[prefix] = val
            window.localStorage.setItem(storageKey, JSON.stringify(store))
            return val
        } else {
            return store[prefix] !== undefined ? store[prefix] : false
        }
    },[car])

    const handleToggle = (name)=>{

        let newIncludedCosts = [...includedCosts]
        if( newIncludedCosts.includes(name) ) {

            newIncludedCosts = newIncludedCosts.filter((val)=>{
                return val !== name;
            })
        } else {
            newIncludedCosts.push(name)
        }
        newIncludedCosts.sort()
        setIncludedCosts(newIncludedCosts)
    }

    const handleSubmitInsurance = useCallback( async (e)=>{
        e.preventDefault()

        const personnummerRegex = new RegExp(/^[0-9]{12}$/) 

        if( !personnummer.current.value.match(personnummerRegex)) {
            alert("Felaktigt personnummer.\n Formatet ska vara ååååmmddxxx, enbart siffror, inklusive fullt årtal")
            return false
        }

        setIsLoading(true)

        const config = {
            headers: {
                'Accept': 'application/json'
            },
            params: {
                'socialId': personnummer.current.value,
                'id': car._id
            }
        }
        const url = `${process.env.REACT_APP_WAYKE_API_URL}/insurance`
        try {
            const results = await axios.get(url, config)
            setInsurance(results.data);

            setIsLoading(false)

        } catch (error) {
            setIsLoading(false)
            if( error.response ){
                console.log(error.response.data); // => the response payload 
            }
            alert('Tyvärr gick något fel, vänligen försök igen senare')
            return;            
        }

    }, [personnummer, car, costs, includedCosts])

    /**
     * Update loan cost on change
     */
    useEffect(()=>{
        let newCost = costs
        newCost.loan = order.monthlyCost
        setCosts(newCost)
    },[order])

    /**
     * Update totalCost when included Costs changes
     */
    useEffect(()=>{
        let newTotal = 0;
        includedCosts.forEach( (key)=>{
            newTotal += costs[key]
        });

        const newSegments = []
        let totalPercentage = 0
        includedCosts.forEach( (key, i) => {
            // console.log({amount:costs[key], key, percentage: Math.floor( (costs[key]/newTotal) * 100)})
            let percentage = Math.floor( (costs[key]/newTotal) * 100)

            if(i === (includedCosts.length - 1) && percentage + totalPercentage !== 100) {
                let offset = 100 - (percentage + totalPercentage);
                // console.log({percentage, offset})
                percentage += offset
            }

            newSegments.push( {
                name: key,
                percentage: percentage
            })
            totalPercentage += percentage
        })
        setTotalCost(newTotal)
        setSegments(newSegments)

    },[includedCosts, insurance, order])

    useEffect(()=>{
        setInsurance(storage())
    },[storage])

    useEffect(()=>{
        storage(insurance)
        if(insurance) {
            const newCosts = Object.assign({},costs)
            newCosts.insurance = insurance.price
            setCosts(newCosts)
    
            if(!includedCosts.includes('insurance')){
                handleToggle('insurance')
            }
        }

    },[insurance, storage])
    return (

        <div className="costs">
            <div className="circle-diagram">
                <CircleGraph segments={segments} />
                <div className="label">
                    Ägandekostnad
                    <span className="total-cost">{ priceFormatter(totalCost, ' kr/mån')}</span>
                </div>
                    
            </div>
            <div className="labels">
                <div className={ includedCosts.includes('loan') ? 'label': 'label disabled' }>
                    <label onClick={ () => { handleToggle('loan') } } htmlFor="cost-lan">
                        <span className="color-indicator loan"></span>
                        <span className="label-name">Billån </span>
                        <span className="label-value">{ priceFormatter(costs.loan, ' kr/mån')}</span>
                    </label>
                </div>
                <div className={ includedCosts.includes('tax') ? 'label': 'label disabled' }>
                    <label onClick={ () => { handleToggle('tax') } } htmlFor="cost-skatt">
                        <span className="color-indicator tax"></span>
                        <span className="label-name">Skatt </span>
                        <span className="label-value">{ priceFormatter(costs.tax, ' kr/mån')} </span>
                        { costs.hasMalus && costs.malusUntil &&
                            <small>
                                Till { costs.malusUntil} , därefter <data className="nowrap">{priceFormatter(costs.taxAfterMalus, ' kr/mån')}</data>
                            </small>
                        }

                        { costs.hasMalus && costs.malusUnti && // show details if car has malus
                            <InfoTag className="ml-1" text={
                                'Beräknas så här: Skatt ' + priceFormatter( car.properties.annualTax, ' kr/år + ') + 
                                'Malus ' + priceFormatter( car.properties.annualMalus, ' kr/år')
                            } />
                        }
                    </label>
                </div>
                {/*<div className={ includedCosts.includes('insurance') || !insurance ? 'label insurance': 'label insurance disabled' }>*/}
                {/*    <label onClick={ () => { handleToggle('insurance') } } htmlFor="cost-forsakring">*/}
                {/*        <span className="color-indicator insurance"></span>*/}
                {/*        <span className="label-name">Försäkring </span>*/}
                {/*        { !insurance && !isLoading && */}
                {/*            <div className='insurance-form'>*/}
                {/*                <input ref={personnummer} pattern="/^[0-9]{12}$/" type="text" placeholder="Personnummer (12 siffror)" />*/}
                {/*                <button onClick={handleSubmitInsurance}>Hämta pris</button>*/}
                {/*            </div>*/}
                {/*        }*/}
                {/*        { isLoading &&*/}
                {/*            <div className="container loading small"></div>*/}
                {/*        }*/}
                {/*        { insurance && !isLoading && */}
                {/*            <span className="label-value">{ priceFormatter(costs.insurance, ' kr/mån')}</span>*/}
                {/*        }*/}
                {/*    </label>*/}
                {/*</div>*/}
                <div className={ includedCosts.includes('tire') ? 'label': 'label disabled' }>
                    <label onClick={ () => { handleToggle('tire') } } htmlFor="cost-dack">
                        <span className="color-indicator tire"></span>
                        <span className="label-name">Däckförvaring </span>
                        <span className="label-value">{ priceFormatter(costs.tire, ' kr/mån')}</span>
                        <InfoTag className="ml-1" text="Ungefärligt pris, varierar mellan anläggning & bilmodell" />
                    </label>
                </div>
                <div className={ includedCosts.includes('service') ? 'label': 'label disabled' }>
                    <label onClick={ () => { handleToggle('service') } } htmlFor="cost-service">
                        <span className="color-indicator service"></span>
                        <span className="label-name">Serviceavtal </span>
                        <span className="label-value">{ priceFormatter(costs.service, ' kr/mån')}</span>
                        <InfoTag className="ml-1" text="Ungefärligt pris, varierar mellan anläggning & bilmodell" />
                    </label>
                </div>
            </div>
        </div>

    )

}

export default Cost